import type { Recipe } from '@/types';
import { time } from '@/time';

const recipe: Recipe = {
  title: 'Cornbread',
  source: 'https://www.seriouseats.com/moist-and-tender-brown-butter-cornbread-recipe',
  totalTime: time(1, 10),
  servings: 8,
  tags: { type: 'side' },
  vessels: { main: { kind: 'skillet', diameter: 10 } },
  wholeOnly: true,
  ingredients: [
    { name: 'unsalted butter', quantity: '7', unit: 'tbsp',
      amountNote: 'plus more for serving',
    },
    { name: 'fine yellow cornmeal', quantity: '1', unit: 'cup' },
    { name: 'all-purpose flour', quantity: '1', unit: 'cup' },
    { name: 'sugar', quantity: '4', unit: 'tbsp' },
    { name: 'kosher salt', quantity: '1', unit: 'tsp' },
    { name: 'baking powder', quantity: '2', unit: 'tsp' },
    { name: 'baking soda', quantity: '1/4', unit: 'tsp' },
    { name: 'eggs', quantity: '2' },
    { name: 'sour cream', quantity: '6', unit: 'oz' },
    { name: 'cultured buttermilk', quantity: '4', unit: 'oz' },
    { name: 'honey' },
  ],
  directions: [
    {
      title: 'Heat oven',
      bullets: [
        "Adjust oven rack to center & preheat to {!425F}",
      ],
    },
    {
      title: 'Brown butter',
      perVessel: true,
      bullets: [
        "Place {unsalted butter} in cast iron {vessel}",
        "Transfer to oven & heat 10–20 min until butter melted & browned",
        "Pour browned butter into heatproof cup, leaving ~{=1 tbsp} in skillet",
      ],
    },
    {
      title: 'Mix batter',
      bullets: [
        "In large bowl, combine {fine yellow cornmeal}, {all-purpose flour}, {sugar}, {kosher salt}, {baking powder} & {baking soda}",
        "In second bowl, whisk {eggs}, {sour cream} & {cultured buttermilk}",
        "Whisking constantly, slowly drizzle reserved browned butter into wet mixture",
        "Stir wet ingredients into dry ingredients until just combined",
      ],
    },
    {
      title: 'Fill skillet',
      perVessel: true,
      bullets: [
        "Swirl hot {vessel} to coat all surfaces with melted butter",
        "Spoon batter into skillet & smooth top lightly",
      ],
    },
    {
      title: 'Bake & serve',
      bullets: [
        "Bake 20–25 min until light golden brown on top & skewer comes out clean",
        "Let cool 10 min",
        "Serve with extra butter & {honey}",
      ],
    },
  ],
};

export default recipe;
